/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { MTemplates } from './templates.js';

export let MVPrint = function($,mj) {

	function open( media_ids, title ) {
		if( media_ids.length == 0 ) return;
		var f = $('#mp-form');
		f.dialog( 'destroy' );
		f.find('[name=media_ids]').val( media_ids.join(',') );
		f.find('[name=title]').val(title);
		f.find('form').attr('action',mj.uwn+'/media/page-print?d='+Date.now());
		if( media_ids.length==1 ) {
			f.find('[name=type][value=single-detail]').prop('checked',true);
			f.find('[name=res][value=8]').prop('checked',true);
		} else {
			f.find('[name=type][value=table]').prop('checked',true);
			f.find('[name=res][value=4]').prop('checked',true);
		}
		f.dialog( { width:440, height:'auto', modal:true, resizable:false, close:function(ev, ui) {
			$(this).dialog('destroy');
		} } ).show();
		f.find('[name=title]').focus();
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_print',open),
	};
}(jQuery,mj); // namespace MVPrint
